module.exports = __webpack_public_path__ + "public/img/11.5c23baa6.png";